import { moveItemToSectionOptimistically } from '../utils/quote-helpers';
import { useQuoteMutation } from './create-quote-mutation';

interface MoveItemVariables {
  itemId: string;
  targetSectionId: string | null;
}

/**
 * Move item to a different section with optimistic updates
 * Item moves immediately in UI before API confirmation
 */
export const useMoveItem = (quoteId: string) =>
  useQuoteMutation<MoveItemVariables>({
    quoteId,
    optimisticUpdate: (quote, { itemId, targetSectionId }) =>
      moveItemToSectionOptimistically(quote, itemId, targetSectionId)
  });
